import CTLBooleanCell from "application/components/CTLBooleanCell";
import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";

const getUpdateColumns = (onEdit, onDelete) => {
  return [
    {
      Header: "Access Code",
      accessor: "extension",
      displayInList: true,
      allowFilter: true,
      allowInForm: true,
      dataType: "string",
      disabled: true,
      width: 6,
      validation: formControl.string().required("Required"),
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Access Type",
      accessor: "data",
      displayInList: true,
      allowFilter: true,
      allowInForm: true,
      dataType: "string",
      width: 6,
      validation: formControl.string().required("Required"),
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Wav Filename",
      accessor: "wavFilename",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
      width: 6,
    },
    {
      Header: "Confirmation Wav File",
      accessor: "confirmationWavFile",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "Dial Number",
      accessor: "dialNumber",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "Number Of Retry",
      accessor: "noOfRetry",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().digitsOnly().nullable(),
      width: 6,
    },
    {
      Header: "NO ANSWER SMS Retry",
      accessor: "noAnsSmsTry",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "integer",
      validation: formControl.string().digitsOnly().nullable(),
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "Retry Interval (In Second)",
      accessor: "retryIntervalInMs",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "integer",
      validation: formControl.string().digitsOnly().nullable(),
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "Sms Text",
      accessor: "smsText",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "SMS Number",
      accessor: "smsNumber",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "Email Id",
      accessor: "configEmailId",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      validation: formControl.string().emailOnly().nullable(),
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "URL",
      accessor: "url",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "Retry Voice Message",
      accessor: "retryVoiceMessage",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "SMS Config",
      accessor: "codeBlueSentSmsConfig",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
      controlType: "select",
      options: {
        keyField: "id",
        keyDescription: "description",
        values: [
          { id: "Disable", description: "Disable" },
          { id: "Always", description: "Always" },
          { id: "No Answer", description: "No Answer" },
        ],
      },
    },
    {
      Header: "Fly Mode",
      accessor: "record",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "boolean",
      controlType: "boolean",
      Cell: ({ value }) => <CTLBooleanCell value={value} />,
      width: 6,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      sortDisable: true,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ),
    },
  ];
};

export { getUpdateColumns };
